import { datadogRumProvider } from '@40seas/frontend/libs/providers';
import { DashboardEventTracker } from '../../../../../libs/providers/dashboardEventTracker/dashboardEventTracker';
import { localStorageProvider } from '../../providers/localStorageProvider';

export const useDashboardEventTracker = (): DashboardEventTracker => {
    return DashboardEventTracker.getInstance();
};

export const useSendDashboardViewPage = () => {
    const dashboardEventTracker = useDashboardEventTracker();

    const locale = localStorageProvider.getRaConfig('locale') || 'en';

    const appVersion = datadogRumProvider.getVersion();

    dashboardEventTracker.trackViewedPage({ locale, appVersion });
};
